(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6757],{

/***/ 7421:
/***/ (function(module) {

class DoubleCenterException {
  constructor () {
    const msg = 'iTooltip Error: positionX and positionY properties cannot be "center" at the same time.'
    window.console.error(msg)
  }
}

class iTooltip {
  constructor (selector = '*') {
    const qs = (selector !== '*') ? selector : '*[title]'
    this.objects = document.querySelectorAll(qs)
  }

  init (options = {}) {
    const defaultOptions = {
      className: 'tooltip', // Changes the class name for a block.
      indentX: 10, // Horizontal indent.
      indentY: 15, // Vertical indent.
      positionX: 'right', // Start horizontal position. Variants: left, center, right
      positionY: 'bottom', // Start vertical position. Variants: top, center, bottom
    }

    this.settings = Object.assign(defaultOptions, options)

    if (this.settings.positionX === 'center'
        && this.settings.positionY === 'center') { throw new DoubleCenterException() }

    this.objects.forEach((obj) => {
      if (obj.getAttribute('title')) {
        obj.addEventListener('mouseenter', event => this.createTooltip(event))
        obj.addEventListener('mouseleave', event => this.removeTooltip(event))
      }
    })
  }

  createTooltip (event) {
    const elem = event.target
    this.tooltip = document.createElement('div')
    this.tooltip.classList.add(this.settings.className)
    this.tooltip.innerHTML = elem.getAttribute('title')
    this.tooltip.style.position = 'absolute'
    this.changePosition(event)
    elem.removeAttribute('title')
    document.body.appendChild(this.tooltip)
    elem.addEventListener('mousemove', event => this.changePosition(event))
  }

  removeTooltip (event) {
    event.target.setAttribute('title', this.tooltip.innerHTML)
    this.tooltip.remove()
  }

  changePosition (event) {
    const [tooltipWidth, tooltipHeight] = this.getSizeTooltip()
    const edges = this.getEdges(event)
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    let horizontalPosition = event.pageY
    let verticalPosition = event.pageX

    if (this.settings.positionX === 'right') {
      verticalPosition = (edges.right <= tooltipWidth)
        ? event.clientX - tooltipWidth - this.settings.indentX
        : event.clientX + this.settings.indentX
    } else if (this.settings.positionX === 'left') {
      verticalPosition = (edges.left <= tooltipWidth)
        ? edges.left + this.settings.indentX
        : event.clientX - tooltipWidth - this.settings.indentX
    } else {
      verticalPosition = (edges.left <= Math.round(tooltipWidth / 2))
        ? event.clientX - edges.left
        : event.clientX - Math.round(tooltipWidth / 2)
    }

    if (this.settings.positionY === 'top') {
      horizontalPosition = (edges.top <= tooltipHeight)
        ? scrollTop + event.clientY + this.settings.indentY
        : event.pageY - tooltipHeight - this.settings.indentY
    } else if (this.settings.positionY === 'bottom') {
      horizontalPosition = (edges.bottom < tooltipHeight
        && edges.top > (tooltipHeight + this.settings.indentY))
        ? event.pageY - tooltipHeight - this.settings.indentY
        : scrollTop + event.clientY + this.settings.indentY
    } else {
      let half = Math.round(tooltipHeight / 2)

      if (edges.bottom <= half) {
        half = Math.round(tooltipHeight - edges.bottom)
      }
      if (edges.top <= half) { half = edges.top }

      horizontalPosition -= half
    }

    this.tooltip.style.top = `${horizontalPosition}px`
    this.tooltip.style.left = `${verticalPosition}px`
  }

  getSizeTooltip () {
    const tooltipClientRect = this.tooltip.getBoundingClientRect()
    const tooltipWidth = tooltipClientRect.right - tooltipClientRect.left
    const tooltipHeight = tooltipClientRect.bottom - tooltipClientRect.top

    return [
      tooltipWidth,
      tooltipHeight,
    ]
  }

  getEdges = (event) => {
    const docElement = document.documentElement

    return {
      left: event.clientX,
      right: docElement.clientWidth - event.clientX,
      top: event.clientY,
      bottom: docElement.clientHeight - event.clientY,
    }
  }
}

module.exports = iTooltip


/***/ }),

/***/ 2691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brighton/seo-design-portfolio/professional-uk-seo",
      function () {
        return __webpack_require__(4237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(362);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9472);
/* harmony import */ var components_common_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2034);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4870);
/* harmony import */ var components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4153);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(545);
/* harmony import */ var components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9266);


// -------- custom component -------- // 





// -------- custom hook -------- //


var details = {
    pageName: "Gold Bear Removals Brighton",
    categories: "seo, bespoke website design",
    description: "Gold Bear Removals is a local removals company based in Brighton, East Sussex. They offer a range of services including house removals, office removals, storage, packing and more. Gold Bear asked us to perform monthly SEO. They rank in the top local results for the most important removals related terms.",
    parentDirectories: "seo-design-portfolio"
};
var Portfolio = data_keywords__WEBPACK_IMPORTED_MODULE_5__.LocalSEOArrays[2].keywords;
var contentRowClass = "row gx-0";
var titleClass = "display-6 mb-4";
var ProjectDetails = function() {
    (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        title: "".concat(Portfolio[0].title, " - ").concat(details.pageName),
                        description: details.description,
                        tag: details.categories,
                        urlPT: "",
                        urlENPT: "",
                        url: "".concat(Portfolio[0].url, "/").concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-")),
                        image: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "overflow-hidden position-relative lightblue",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container gx-0 text-center wrapper image-wrapper bg-image bg-overlay text-white overflow-hidden d-flex align-items-center",
                            style: {
                                paddingBottom: "20%"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "hero-portfolio position-absolute left-0 top-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "",
                                        src: "/img/clients/".concat(Portfolio[1].title.toLowerCase().replace(/ /g, "-"), "-bg.jpg"),
                                        // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                                        alt: "".concat(Portfolio[1].title)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-md-12 mx-auto text-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "post-header mx-auto text-center pt-10",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                    className: "fs-15 text-uppercase text-dark mb-3",
                                                    children: [
                                                        "- ",
                                                        Portfolio[0].title,
                                                        " -"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "display-4 text-dark text-capitalize",
                                                    children: details.pageName
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "wrapper bg-light wrapper-border",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-lg-12 offset-lg-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: titleClass,
                                                children: Portfolio[0].title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "overflow-hidden ".concat(contentRowClass),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-lg-8 text-justify order-0 pe-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                    className: "caption",
                                                                    children: details.description
                                                                })
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "position-relative",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    width: "100%",
                                                                    height: "auto",
                                                                    src: "/img/clients/page-1-google-local.jpg",
                                                                    alt: "Page 1 Google Local",
                                                                    style: {
                                                                        background: "transparent"
                                                                    },
                                                                    className: "mb-10 mw"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                children: [
                                                                    "Local & ",
                                                                    Portfolio[1].title
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                children: [
                                                                    "SEOptimist created a customized digital marketing strategy to help Gold Bear Removals achieve their online goals. They wanted to focus on local SEO services rather than ",
                                                                    Portfolio[1].title,
                                                                    ", targeting customers in the Brighton area."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                children: [
                                                                    "To achieve this, SEOptimist  ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[2].title,
                                                                        href: "/"
                                                                    }),
                                                                    " conducted extensive keyword research to identify the most relevant keywords that Gold Bear Removals' target audience was searching for in their local area. We then implemented a comprehensive local SEO strategy, including optimizing their Google My Business profile, creating local citations, and building high-quality backlinks from local websites."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                width: "100%",
                                                                height: "auto",
                                                                src: "/img/clients/".concat(Portfolio[2].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                                alt: Portfolio[2].title,
                                                                style: {
                                                                    background: "transparent"
                                                                },
                                                                className: "mb-10 mw"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: Portfolio[2].title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: "Through our ongoing SEO efforts, we were able to help Gold Bear Removals achieve number 1 results for their desired keywords in Google's local search results. This helped them attract more local customers and increase their revenue."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: "But our digital marketing efforts didn't stop there. We also implemented a content marketing strategy, creating high-quality blog posts and social media content that provided value to Gold Bear Removals' target audience. This helped establish Gold Bear Removals as an authority in their field and generated leads and sales."
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                width: "100%",
                                                                height: "auto",
                                                                src: "/img/clients/national-uk-seo-brighton.jpg",
                                                                alt: "National UK SEO Brighton",
                                                                style: {
                                                                    background: "transparent"
                                                                },
                                                                className: "mb-5 mw"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                children: [
                                                                    "As a ",
                                                                    Portfolio[2].title,
                                                                    " agency, SEOptimist  ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        title: data_keywords__WEBPACK_IMPORTED_MODULE_5__.HomeList[0].title,
                                                                        href: "/"
                                                                    }),
                                                                    " ",
                                                                    "understands the unique challenges that businesses in Brighton face when it comes to digital marketing. That's why we offer customized solutions to help businesses achieve their online goals. Contact us today to learn more about our local SEO services and how we can help your business achieve success online."
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                title: "Contact",
                                                                href: "/#contact",
                                                                className: "more hover"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {})
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "col-lg-4 ms-auto order-1 pt-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                width: "300",
                                                                height: "auto",
                                                                src: "/img/clients/".concat(Portfolio[0].title.toLowerCase().replace(/ /g, "-"), ".jpg"),
                                                                alt: Portfolio[0].title,
                                                                style: {
                                                                    background: "transparent"
                                                                },
                                                                className: "mb-10"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                className: "mb-1 text-initial ps-1",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                                                                    children: "Google results"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                className: "list-unstyled",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                className: "mb-1",
                                                                                children: "Categories"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                children: details.categories
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                className: "mb-1",
                                                                                children: "Client Name"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                children: details.pageName
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_portfolio__WEBPACK_IMPORTED_MODULE_2__/* .LocalSEO */ .wx, {
                                    initialslide: 4
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ProjectDetailsNavigation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_reuseable_ContactFooterCombo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                location: "brighton"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectDetails);


/***/ }),

/***/ 4153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var ProjectDetailsNavigation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "wrapper bg-light"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProjectDetailsNavigation);


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 959:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useIsotope = function() {
    var isotope = useRef();
    var ref = useState("*"), filterKey = ref[0], setFilterKey = ref[1];
    useEffect(function() {
        if (false) {}
        _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var Isotope, grids;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return __webpack_require__.e(/* import() */ 3391).then(__webpack_require__.t.bind(__webpack_require__, 3391, 23));
                    case 2:
                        Isotope = _ctx.sent.default;
                        grids = document.querySelectorAll(".grid");
                        if (grids !== null) {
                            grids.forEach(function(g) {
                                var grid = g.querySelector(".isotope");
                                isotope.current = new Isotope(grid, {
                                    itemSelector: ".item",
                                    layoutMode: "masonry",
                                    masonry: {
                                        columnWidth: grid.offsetWidth / 12
                                    },
                                    percentPosition: true,
                                    transitionDuration: "0.7s"
                                });
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        return function() {
            var ref;
            return (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.destroy();
        };
    }, []);
    useEffect(function() {
        var ref;
        var filtered = filterKey === "*" ? {
            filter: "*"
        } : {
            filter: filterKey
        };
        (ref = isotope.current) === null || ref === void 0 ? void 0 : ref.arrange(filtered);
    }, [
        filterKey
    ]);
    // change filter item
    var handleFilterKeyChange = function(key) {
        return function() {
            return setFilterKey(key);
        };
    };
    return {
        handleFilterKeyChange: handleFilterKeyChange,
        filterKey: filterKey
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useIsotope)));


/***/ }),

/***/ 545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var useTooltip = function() {
    // added tooltip library
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var iTooltip, tooltip;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        iTooltip = __webpack_require__(7421);
                        tooltip = new iTooltip(".itooltip");
                        tooltip.init({
                            indentX: 15,
                            indentY: 15,
                            positionX: "right",
                            positionY: "bottom",
                            className: "itooltip-inner"
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (useTooltip);


/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var carouselBreakpoints = {
    0: {
        slidesPerView: 1
    },
    768: {
        slidesPerView: 2
    },
    1200: {
        slidesPerView: 3
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (carouselBreakpoints);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,4870,4556,6435,362,9774,2888,179], function() { return __webpack_exec__(2691); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);